import {
  Input,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  Button,
  useToast,
  Box,
  ModalCloseButton,
} from "@chakra-ui/react";
import React from "react";
import Axios from "../../../services/axios";
import "../styles/add-modal.css";

function AddModal({ isOpen, onClose, type, input, setInput, fetchData }) {
  const toast = useToast();

  function adjustCommissionRate(value) {
    let adjustedValue = +value;

    if (adjustedValue > 100) return 100;
    if (adjustedValue < 0) return 0;

    return adjustedValue;
  }

  const handleInputChange = (e) => {
    let tempObj = { ...input };
    let value = e.target.value;

    if (e.target.name === "commissionRate" && e.target.type === "number") {
      value = adjustCommissionRate(value);
    }
    
    tempObj[e.target.name] = value;
    setInput(tempObj);
  };

  const validationSubmit = () => {
    let isValid = {
      status: "success",
      message: `Berhasil ${
        type === "add" ? "menambahkah" : "mengubah"
      } komunitas`,
    };

    Object.keys(input).forEach((key) => {
      if ((!input[key] && key !== "commissionRate") || (key === "commissionRate" && !input.commissionRate && typeof input.commissionRate !== "number")) {
        isValid.status = "warning";
        isValid.message = "Mohon mengisi kode/nama/komisi terlebih dahulu";
      }
    });

    return isValid;
  };

  const handleAdd = async () => {
    let isValid = validationSubmit();
    if (isValid.status === "success") {
      try {
        if (type === "add") {
          await Axios({
            url: "/admin/community",
            method: "POST",
            data: input,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          });
        } else if (type === "edit") {
          await Axios({
            url: `/admin/community/${input.code}`,
            method: "PUT",
            data: input,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          });
        }
        fetchData();
        onClose();
        toast({
          title: "Success",
          description: isValid.message,
          status: isValid.status,
          position: "top",
          duration: 1500,
          isClosable: true,
        });
      } catch (err) {
        console.error(err.response);
        toast({
          title: "Warning",
          description: err.response.data.errors[0].message,
          status: "warning",
          position: "top",
          duration: 1500,
          isClosable: true,
        });
      }
    } else {
      toast({
        title: "Warning",
        description: isValid.message,
        status: isValid.status,
        position: "top",
        duration: 1500,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW={"1000px"}>
        <ModalCloseButton />
        <Text className="modal-title">
          {type === "add" ? "Create New" : "Edit"} Community
        </Text>
        <Box style={{ alignItems: "center", marginBottom: "16px", padding: "0 24px" }}>
          <Text className="modal-label">Community Code<span style={{ color: "#E6001C"}}>*</span></Text>
          <Input
            placeholder="Community Code"
            name="code"
            value={input.code}
            onChange={(e) => handleInputChange(e)}
            disabled={type === "edit"}
            fontSize="14px"
            _placeholder={{ color: "#ADADAD" }}
          />
        </Box>
        <Box style={{ alignItems: "center", marginBottom: "16px", padding: "0 24px" }}>
          <Text className="modal-label">Community Name<span style={{ color: "#E6001C"}}>*</span></Text>
          <Input
            placeholder="Community Name"
            name="name"
            onChange={(e) => handleInputChange(e)}
            value={input.name}
            fontSize="14px"
            _placeholder={{ color: "#ADADAD" }}
          />
        </Box>
        <Box style={{ alignItems: "center", marginBottom: "24px", padding: "0 24px" }}>
          <Text className="modal-label">Commission (%)<span style={{ color: "#E6001C"}}>*</span></Text>
          <Input
            type="number"
            placeholder="Percentage Commmission"
            name="commissionRate"
            onChange={(e) => handleInputChange(e)}
            value={input.commissionRate}
            fontSize="14px"
            _placeholder={{ color: "#ADADAD" }}
            onKeyDown={(e) => {
              if ([",", "-", ".", "e", "E"].includes(e.key)) {
                e.preventDefault();
              }
            }}
            onInput={(e) => {
              let value = e.target.value;
              if (/^0+\d/.test(value)) {
                value = value.replace(/^0+/, "");
                e.target.value = value;
              }
            }}
            onPaste={(e) => {
              const pasted = (e.clipboardData || window.clipboardData).getData("text");

              let num = +(pasted.replace(",", "."));

              if (isNaN(num)) {
                e.preventDefault();
              } else {
                num = adjustCommissionRate(Math.round(num));
                e.preventDefault();
                e.target.value = num;
              }
            }}
          />
        </Box>
        <Box padding="0 24px 24px 24px">
          <Button className="modal-save__button" color="#fff" onClick={() => handleAdd()}>
            Save
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
}

export default AddModal;
